export default {
  id: 'push_jobs',
  title: 'Promote jobs',
  type: 'Direct',
  canSendToChannel: false,
  relations: [ 'MANY_JOBS' ],
  description: 'Send a message encouraging colleagues to share jobs.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_MESSAGE_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
    ],
  },
  inputs: {
    INPUT_MESSAGE_TEXT: {
      label: 'Message',
      placeholder: 'Share the following jobs with your network…',
      defaultValue: 'Share the following jobs with your network to win rewards!',
      type: 'HTML'
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/push/promoteJobs.js